module.exports = __webpack_public_path__ + "static/joan-baldovi-2-c240b9bbb38039617070d52ecf4d799e.jpg";